import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Container } from '../Container';
import { Reveal } from '../Reveal';
import { AppImage } from '../AppImage';
import type { CaseStudy, Project } from '../../types/content';
interface CaseStudyHeroProps {
  project: Project;
  study: CaseStudy;
  heroImage: {
    image: string;
    alt: string;
  };
}
export function CaseStudyHero({
  project,
  study,
  heroImage
}: CaseStudyHeroProps) {
  return <>
      <section className="bg-canvas pb-14 pt-[96px] lg:pb-16 lg:pt-[152px]" data-id="element-154" data-mp="1xmb1wqxyt739">
        <Container data-id="element-155" data-mp="2blkhppi9dz6p">
          <Reveal data-id="element-156" data-mp="2bm3p4caa956h">
            <Link to="/work" className="inline-flex items-center gap-2 text-small text-muted transition-colors duration-150 ease-out hover:text-ink" data-id="element-157" data-mp="2bmlsdsvd4jnw">
              <ArrowLeftIcon size={16} aria-hidden="true" data-id="element-158" data-mp="3mzy0wh22hqge" />
              All work
            </Link>

            {project.isConcept && <p className="mt-10 text-[12px] uppercase tracking-[0.06em] text-[#6E6E6E]" data-id="element-159" data-mp="3i1eg4jz7mkpm">
                Self-initiated concept
              </p>}
            <p className={`text-small text-muted ${project.isConcept ? 'mt-3' : 'mt-10'}`} data-id="element-160" data-mp="2a1ejmc2b3af3">
              {project.client}
            </p>

            <h1 className="mt-5 max-w-[20ch] font-serif text-[clamp(40px,5vw,72px)] font-normal leading-[1.05] tracking-[-0.03em] text-ink" data-id="element-161" data-mp="2ez7qz8fciagy">
              {project.headline}
            </h1>
            <p className="mt-8 max-w-measure border-t border-hairline pt-6 text-body text-muted" data-id="element-162" data-mp="1meg9rx8oz0q5">
              {study.summary}
            </p>
          </Reveal>
        </Container>
      </section>

      <Container data-id="element-163" data-mp="1w9hxqpr8dwr5">
        <Reveal data-id="element-164" data-mp="1w8yen5puh2bj">
          <AppImage src={heroImage.image} alt={heroImage.alt} ratio="16:10" data-id="element-165" data-mp="211j8g78r3ff2" />
        </Reveal>
      </Container>
    </>;
}